import {
  Text,
  InlineChildren,
  Spacing,
  StackChildren,
  Media,
} from '@doordash/design-language'
import styled from 'styled-components'

export const SectionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

type TextProps = {
  center?: boolean
}
export const SectionContainer = styled(StackChildren)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: ${(props: TextProps) => (props.center ? 'center' : 'left')};
`

export const TextContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;

  ${Media.Mobile`
    width: 100%;
  `}

  * + * {
    margin: 0 !important;
  }
`

export const TextElement = styled.div`
  padding: ${Spacing.Small}px;
  flex: 1 1 0px;
`

export const TextItem = styled(Text)`
  padding: ${Spacing.XSmall}px;
`

export const InlineContent = styled(InlineChildren)`
  width: 100%;
`

export const StackContent = styled(StackChildren)`
  width: 100%;
`
